import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

interface GroupCompletionDialogProps {
  open: boolean;
  onConfirm: () => void;
  currentGroupName?: string;
  nextGroupName?: string;
  isLoading?: boolean;
}

const GroupCompletionDialog: React.FC<GroupCompletionDialogProps> = ({
  open,
  onConfirm,
  currentGroupName,
  nextGroupName,
  isLoading = false
}) => {
  return (
    <Dialog open={open} onOpenChange={() => { }} modal>
      <DialogContent
        className="sm:max-w-md bg-white border-0 shadow-2xl text-center [&>button]:hidden"
        id="group-completion-dialog"
        data-testid="group-completion-dialog"
        
      >
        <DialogHeader className="text-center pb-6">
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-4 rounded-full">
              <Info className="h-8 w-8 text-white" />
            </div>
          </div>
          <DialogTitle
            className="text-2xl font-bold text-gray-800 text-center"
            id="group-completion-title"
            data-testid="group-completion-title"
          >
            Group Information
          </DialogTitle>
        </DialogHeader>

        <div className="text-center py-6">
          <p
            className="text-gray-600 text-lg leading-relaxed text-center mx-auto max-w-sm"
            id="group-completion-message"
            data-testid="group-completion-message"
          >
            Current Group Has Been Completed, Switching to Next Available Group
          </p>
        </div>

        <div className="flex justify-center pt-6">
          <Button
            id="group-completion-ok-button"
            name="groupCompletionOk"
            data-testid="group-completion-ok-button"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white px-12 py-3 font-medium text-lg"
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Loading...
              </>
            ) : (
              'Ok'
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GroupCompletionDialog;